import type { SVGProps } from 'react';

const ReactComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 65 98"
    {...props}
  >
    <path
      fill="#FFDA65"
      fillRule="evenodd"
      d="m16.72 57.686-.001 37.186 15.678-12.246 15.676 12.246V57.645"
      clipRule="evenodd"
    />
    <path
      fill="#FFC23B"
      fillRule="evenodd"
      d="M48.074 54.736a2.91 2.91 0 0 1 2.908 2.909v37.227a2.909 2.909 0 0 1-4.699 2.292L32.397 86.317 18.51 97.164a2.908 2.908 0 0 1-4.7-2.292l.001-37.187a2.909 2.909 0 0 1 5.818 0l-.001 31.224 10.979-8.575a2.91 2.91 0 0 1 3.58 0l10.978 8.575V57.645a2.91 2.91 0 0 1 2.909-2.909"
      clipRule="evenodd"
    />
    <path
      fill="#FFDA65"
      fillRule="evenodd"
      d="M32.396 61.781c15.991 0 28.955-12.963 28.955-28.955 0-15.99-12.964-28.954-28.955-28.954S3.441 16.835 3.441 32.826s12.964 28.955 28.955 28.955"
      clipRule="evenodd"
    />
    <path
      fill="#FFC23B"
      fillRule="evenodd"
      d="M.533 32.826C.533 15.23 14.798.963 32.396.963S64.259 15.23 64.259 32.826 49.994 64.69 32.396 64.69.533 50.424.533 32.826M32.396 6.78C18.011 6.78 6.35 18.442 6.35 32.826c0 14.385 11.661 26.047 26.046 26.047S58.442 47.21 58.442 32.826 46.781 6.78 32.396 6.78"
      clipRule="evenodd"
    />
  </svg>
);
export { ReactComponent };
